import { AnimatePresence, motion } from 'framer-motion';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useDOMWidth from '../hooks/useDOMWidth';
import { setViewImages } from '../store/viewImages';
import icons from '../utils/icons.json';

const parentVariants = {
	initial: {},
	animate: {},
};

const leftBtnVariant = {
	initial: {
		left: -50,
		scale: 0,
	},
	animate: {
		left: 10,
		scale: 1,
		transition: {
			duration: 0.3,
		},
	},
};

const rightBtnVariant = {
	initial: {
		right: -50,
		scale: 0,
	},
	animate: {
		right: 10,
		scale: 1,
		transition: {
			duration: 0.3,
		},
	},
};

function ImageViewer() {
	const dispatch = useDispatch();
	const viewImages = useSelector(state => state.viewImages.data);
	const [visible, setVisibility] = useState(false);

	const domWidth = useDOMWidth(window.innerWidth);
	const [position, setPosition] = useState(0);

	const [frameWidth, setFrameWidth] = useState(0);
	const [sliderWidth, setSliderWidth] = useState(0);

	const sliderFrame = useRef(null);
	const slider = useRef(null);

	useEffect(() => {
		if (viewImages.length > 0) {
			setVisibility(true);
		} else {
			setVisibility(false);
		}
	}, [viewImages]);

	useEffect(() => {
		if (sliderFrame.current) {
			setFrameWidth(sliderFrame.current.offsetWidth);
		}
		if (slider.current) setSliderWidth(slider.current.scrollWidth);
	}, [sliderFrame, slider, domWidth]);

	useEffect(() => {
		setPosition(0);
	}, [frameWidth, sliderWidth]);

	function moveLeft(e) {
		setPosition(prev => {
			let pos = prev - frameWidth;
			return pos > 0 ? pos : 0;
		});
	}

	function moveRight(e) {
		setPosition(prev => {
			let pos = prev + frameWidth;
			return pos + frameWidth <= sliderWidth ? pos : sliderWidth - frameWidth;
		});
	}

	return !visible ? (
		''
	) : (
		<motion.div variants={parentVariants} initial='initial' animate='animate' className='image-viewer' ref={sliderFrame}>
			<div className='slider' ref={slider} style={{ left: `-${position}px` }}>
				{viewImages.map((url, index) => (
					<section key={url + index} className='slides' style={{ backgroundImage: `url(${url})` }}></section>
				))}
			</div>
			<button onClick={() => dispatch(setViewImages([]))} type='button' className='close-btn' dangerouslySetInnerHTML={{ __html: icons.times }} />
			<AnimatePresence>
				{position > 0 && (
					<motion.button
						variants={leftBtnVariant}
						exit={{
							left: -50,
							scale: 0,
							transition: {
								duration: 0.3,
							},
						}}
						onClick={moveLeft}
						type='button'
						className='s-btn left'
						dangerouslySetInnerHTML={{ __html: icons.angle_left }}
					/>
				)}
			</AnimatePresence>
			<AnimatePresence>
				{position != sliderWidth - frameWidth && (
					<motion.button
						variants={rightBtnVariant}
						exit={{
							right: -50,
							scale: 0,
							transition: {
								duration: 0.3,
							},
						}}
						onClick={moveRight}
						type='button'
						className='s-btn right'
						dangerouslySetInnerHTML={{ __html: icons.angle_right }}
					/>
				)}
			</AnimatePresence>
		</motion.div>
	);
}

export default React.memo(ImageViewer);
